import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import {main_url} from  './basefile';
import { formatDate } from '../utils/dateFormat';

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from '@mui/lab';
import { Typography, Paper, CircularProgress } from '@mui/material';
import { yellow } from '@mui/material/colors';

const TimelineComponent = ({ exeID, refreshKey }) => {
  
  const navigate = useNavigate();
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('authToken');


 //alert(exeID);
  useEffect(() => {

    const fetchSchedules = async () => {
      try {
        const token  = localStorage.getItem('authToken');  
        
        const res = await fetch(`${main_url}/api/v1/executions/${exeID}/schedules/`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!res.ok) throw new Error('Failed to fetch schedules');

        const data = await res.json();
       // alert(JSON.stringify(data));
        
        setSchedules(data.results || []);
      } catch (error) {
        console.error('Error fetching schedules:', error);
        setSchedules([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSchedules();
  }, [exeID, token, refreshKey]);


  function getDateRange(actualDate, windowSize) {

     //have check for actual date as null , say return No Buffer
    
   if (!actualDate) {
    return 'No Buffer';   // null, undefined, or empty string
  }

     const actual = new Date(actualDate);
     const wsize = isNaN(Number(windowSize)) ? 0 : Number(windowSize);

    const start = new Date(actual);
    start.setDate(start.getDate() - wsize);

    
    const end = new Date(actual);
    end.setDate(end.getDate() + wsize);

    if (wsize === 0)
      return 'No Buffer';

    return `${formatDate(start)} - ${formatDate(end)}`;

  }



  const handleItemClick = (scheduleId) => {

    // pass only two item execution id, and schedule id , window_size
    navigate(`/Process_schedule/${scheduleId.project}/${scheduleId.patient}/${scheduleId.id}/${exeID}/${scheduleId.actual_date}/${scheduleId.status}/${scheduleId.window_size}`);

  };

  if (loading) return <CircularProgress sx={{ display: 'block', margin: 'auto', mt: 4 }} />;

  if (schedules.length === 0) {
    return (
      <Typography variant="h6" color="text.secondary" align="center" mt={4}>
        No schedules available
      </Typography>
    );
  }

  return (
    <Box sx={{ ml:1, width:800,  display:'flex',   }} >
    <Timeline position="right" >
      {schedules.reverse().map((item, index) => (
        <TimelineItem
          key={item.order}
          onClick={() => handleItemClick(item)}
          sx={{ cursor: 'pointer', 
              '&:hover': { } }}
        >
          <TimelineOppositeContent color="text.secondary">
            {index+1}   
          </TimelineOppositeContent>

          <TimelineSeparator>
            <TimelineDot color={item.status === 'completed' ? 'success' : 'primary'} />
            {index < schedules.length - 1 && <TimelineConnector sx={{ height: 150 }} />}
          </TimelineSeparator>

          <TimelineContent>
            <Paper elevation={3} sx={{ p: 2, width: '85%', borderRadius:3, backgroundColor: '#f9f9f9'
              , cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: '#91adc4ff', // Light blue on hover
                  },
             }}>
              <Typography variant="h6"  >

             
{`Schedule Date: ${
  item?.actual_date
    ? formatDate(item.actual_date)
    : "N/A"
}`}
               
                
                </Typography>
              <Typography>{`Type: ${item.schedule_type}`}</Typography>

              <Typography fontWeight="bold">{`Status: ${item.status}`}</Typography>

            <Typography variant="subtitle3">
                  Buffer Window: {getDateRange(item.actual_date, item.window_size)}
                </Typography>
                            
            </Paper>
          </TimelineContent>

        </TimelineItem>
      ))}
    </Timeline>
    </Box>
  );
};

export default TimelineComponent;
